import React, { useState } from "react";
import { Col, Form, Row, Spinner } from "reactstrap";
import { changePassword } from "../../../../api/customer";
import PasswordInput from "../../../../helpers/Common/PasswordInput";
import { CustomSnackbar } from "../../../../helpers/CustomSnackbar";

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [retypePassword, setConfirmPassword] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();

    console.log("New Password:", newPassword);
    console.log("Confirm Password:", retypePassword);

    if (newPassword.length < 8) {
      CustomSnackbar.error("Password must be at least 8 characters long");
      return;
    }

    if (newPassword !== retypePassword) {
      CustomSnackbar.error("New password and confirm password does not match");
      return;
    }

    setLoading(true);

    // ✅ send BOTH fields to API
    changePassword({
      newPassword: newPassword,
      retypePassword: retypePassword
    })
      .then((res) => {
        console.log("API Response:", res);

        if (res.status === 200) {
          CustomSnackbar.success("Password updated successfully");

          // optional: clear fields after success
          setNewPassword("");
          setConfirmPassword("");
        }
      })
      .catch((err) => {
        console.log("API Error:", err);

        if (err?.response?.data?.message) {
          CustomSnackbar.error(err.response.data.message);
        } else {
          CustomSnackbar.error("Something went wrong");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form onSubmit={onSubmit}>
      <div className="mt-2">
        <Row>
          <Col lg={12}>
            <div className="mb-3">
              <PasswordInput
                label="New password *"
                name="new-password-input"
                value={newPassword}
                placeholder="Enter new password"
                id="new-password-input"
                required={true}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <PasswordInput
                label="Confirm New Password *"
                name="confirm-password-input"
                value={retypePassword}
                placeholder="Confirm new password"
                id="confirm-password-input"
                required={true}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
          </Col>
        </Row>

        <div className="mt-4 text-end">
          {loading ? (
            <button type="button" className="btn btn-primary disabled w-100">
              Update <Spinner size="sm" />
            </button>
          ) : (
            <button type="submit" className="btn btn-primary w-100">
              Update
            </button>
          )}
        </div>
      </div>
    </Form>
  );
};

export default ChangePassword;
